module.exports = __webpack_public_path__ + "static/media/files.88eddf1a.svg";